if (!customElements.get('delphy-gift-progress')) {
  customElements.define('delphy-gift-progress', class extends HTMLElement {
    connectedCallback() {
      this.update();
      this.onRatesLoaded = () => this.update();
      document.addEventListener('delphy:currency-ready', this.onRatesLoaded);
    }

    disconnectedCallback() {
      document.removeEventListener('delphy:currency-ready', this.onRatesLoaded);
    }

    update() {
      const currency = this.dataset.currency;
      const subtotal = Number(this.dataset.subtotal);
      const hasGift = this.dataset.hasGift === 'true';
      const message = this.querySelector('[data-gift-message]');
      const terms = this.querySelector('[data-gift-terms]');
      const meter = this.querySelector('progress');
      let threshold = 10000;
      let giftValue = 2500;

      if (currency !== 'USD') {
        if (typeof window.Currency?.convert !== 'function') {
          if (hasGift) message.textContent = this.dataset.added;
          return;
        }
        threshold = Math.ceil(window.Currency.convert(10000, 'USD', currency));
        giftValue = Math.round(window.Currency.convert(2500, 'USD', currency));
      }

      if (!Number.isFinite(threshold) || threshold <= 0 || !Number.isFinite(subtotal)) return;
      const fractionDigits = new Intl.NumberFormat('en', { style: 'currency', currency }).resolvedOptions().maximumFractionDigits;
      const divisor = fractionDigits === 0 ? 100 : 10 ** fractionDigits;
      const format = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency, currencyDisplay: 'code'
      }).format(cents / divisor);
      const approximate = (amount) => currency === 'USD' ? amount : this.dataset.approximate.replace('__AMOUNT__', amount);
      const remaining = Math.max(0, threshold - subtotal);

      message.textContent = hasGift ? this.dataset.added : remaining > 0
        ? this.dataset.remaining.replace('__AMOUNT__', approximate(format(remaining)))
        : this.dataset.unlocked;
      const thresholdText = currency === 'USD' ? format(threshold) : approximate(format(threshold)) + ' (US$100)';
      const valueText = currency === 'USD' ? format(giftValue) : approximate(format(giftValue)) + ' (US$25)';
      terms.textContent = this.dataset.terms.replace('__VALUE__', valueText).replace('__THRESHOLD__', thresholdText);
      meter.max = threshold;
      meter.value = Math.min(subtotal, threshold);
      meter.hidden = false;
    }
  });
}
document.dispatchEvent(new Event('delphy:currency-ready'));

